import React, { FC, useContext, useEffect } from 'react';
import dogNBabyPic from 'assets/images/dogAndBaby.png';
import adoptADogPic from 'assets/images/adoptADog.png';
import InstitutionCard from 'components/InstitutionCard';
import ErrorAlert from 'components/ErrorAlert';
import { DataContext } from 'hooks/HeaderContext';


const AdoptPage: FC = () => {

    const {
        filteredInstitutionList,
        institutionsError
    } = useContext(DataContext);

    useEffect(() => {
        document.title = 'How to Adopt • Puppies For Parole'
    }, [])


    return (
        <section id="adopt">
            <div className='px-3 pt-4 d-lg-none container-fluid'>
                <div className='mb-3 d-flex flex-wrap'>
                    <div className='col-12 col-sm-8 col-md-9  order-sm-1 order-0'>
                        <h1 className="font-primary ">How To Adopt ...</h1>
                        <p>Dogs participating in the Puppies for Parole program are available for adoption
                            through our partnering shelters. Each correctional facility partners with a
                            shelter(s) that facilitates the adoptions. The shelter determines the criteria
                            used for the adoption application process and also sets the adoption fee. </p>
                    </div>
                    <div className='col col-sm-4 col-md-3  mb-3 text-center mx-auto order-sm-0 order-1'>
                        <img src={adoptADogPic} className='rounded me-3' alt='young girl with dog' />
                    </div>
                </div>
                <div className='d-flex'>
                    <p>For more information about adopting a dog, contact the partnering shelter where
                        the dog is from. Below is the listing of current partnering shelters and their
                        contact information.</p>
                </div>
            </div>
            <div className="container-lg pt-4 d-none d-lg-flex ">
                <div className='col-lg-2 pe-3 '>
                    <img src={adoptADogPic} className='img-fluid rounded w-100' alt='young girl with dog' />
                </div>
                <div className='col-lg-8'>
                    <h1 className="font-primary">How To Adopt ...</h1>
                    <p>Dogs participating in the Puppies for Parole program are available for adoption
                        through our partnering shelters. Each correctional facility partners with a
                        shelter(s) that facilitates the adoptions. The shelter determines the criteria
                        used for the adoption application process and also sets the adoption fee. </p>
                    <p>For more information about adopting a dog, contact the partnering shelter where
                        the dog is from. Below is the listing of current partnering shelters and their
                        contact information.</p>
                </div>
                <div className='col-lg-2 ps-3 mt-auto'>
                    <img src={dogNBabyPic} className='img-fluid rounded w-100' alt='sleeping baby with dog' />
                </div>
            </div>
            <div className="container-lg mt-4">
                {institutionsError &&
                    <ErrorAlert error={institutionsError} showAlert={true} alertType={'danger'} />
                }
                {!institutionsError &&
                    <>
                        <h2 className="font-primary pt-3">Institutions and Partnering Shelter(s)</h2>
                        <div className="content-wrapper " id="institution-list">
                            {filteredInstitutionList.map(item => <InstitutionCard institution={item} key={item.acronym} />)}
                        </div>
                    </>
                }
            </div>
        </section >
    )
}

export default AdoptPage;




















